import { render } from "./TableBucketCheck.vue?vue&type=template&id=08da1d45&scoped=true"
import script from "./TableBucketCheck.vue?vue&type=script&lang=js"
export * from "./TableBucketCheck.vue?vue&type=script&lang=js"

import "./TableBucketCheck.vue?vue&type=style&index=0&id=08da1d45&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Gerente de TI\\Downloads\\temp\\JB\\new-project\\jb-ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-08da1d45"]])

export default __exports__